import axios from "axios";

// const baseUrl = `http://localhost:7029/`;
const baseUrl = `/`;

export const fetchGamesApi = async () => {
    const response = await axios.get(`${baseUrl}api/games`);
    return response;
} 